"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cache = require("@deosite/helpers/cache");
var _addSortFilters = _interopRequireDefault(require("../../common/addSortFilters"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useProductsAndFiltersFromCategory = function useProductsAndFiltersFromCategory(categoryId, pickedFilters, page, pageSize, query, lang, fetchedData, router, cacheSSR) {
  var _data$filters;
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var fetchedDataCache = (0, _cache.getResultFromCache)(decodeURI(router.asPath).replace(/p=[0-9]*/, "p=".concat(page)), cacheSSR);
  var data = fetchedDataCache !== null && fetchedDataCache !== void 0 ? fetchedDataCache : fetchedData;
  if (!((_data$filters = data.filters) !== null && _data$filters !== void 0 && _data$filters.find(function (filter) {
    return filter.id === "sort";
  }))) {
    (0, _addSortFilters["default"])(data.filters, translations, true);
  }
  (0, _addSortFilters["default"])(data.narrowedFilters, translations);
  return {
    data: _objectSpread({}, data)
  };
};
var _default = useProductsAndFiltersFromCategory;
exports["default"] = _default;